(function () {
    'use strict';

    angular.module('app').controller('ScheduledPickupModalController', ScheduledPickupModalController);

    ScheduledPickupModalController.$inject = [
        '$uibModalInstance',
        'schedule',
        'Carrier',
        'ClientService',
        'toastr'
    ];

    function ScheduledPickupModalController(
        $uibModalInstance,
        schedule,
        Carrier,
        ClientService,
        toastr
    ) {

        let vm = this;
        vm.schedule = {};
        vm.schedule.firstMile = {}; 
        vm.schedule.lastMile = {};
        vm.onSelectCarrierProfile = onSelectCarrierProfile;
        vm.searchCarrierProfiles = searchCarrierProfiles;
        vm.searchServiceProfile = searchServiceProfile;
        vm.searchOffices = searchOffices;
        vm.closeModal = closeModal;
        vm.save = save;

        init();

        function init() {
            vm.isBreakBulk = angular.getObjVal(schedule, 'carrierProfile.carrierId') === 'break-bulk';
            initDaysOpt();
            formatScheduleToEditMode();
        }

        function initDaysOpt() {
            vm.days = [];
            for (let i = 1; i < 32; i++) {
                vm.days.push({
                    name: `${i} - days`,
                    value: i
                });
            }
        }

        function formatScheduleToEditMode() {
            angular.extend(vm.schedule, {
                officeId: angular.getObjVal(schedule, 'officeId'),
                id: angular.getObjVal(schedule, 'id'),
                carrierProfile: angular.getObjVal(schedule, 'serviceProfile.carrierProfile'),
                serviceProfile: angular.getObjVal(schedule, 'serviceProfile'),
                pickupTimeValue: buildTimeData((schedule.pickupTime)) || {},
                cutoffValue: buildTimeData((schedule.cutoff)) || {},
                daysBeforeLastMilePickup: getDaysData(angular.getObjVal(schedule, 'daysBeforeLastMilePickup')),
                frequency: buildScheduleData(schedule.frequencyFormat) || {},
                firstMile: {
                    pickupTimeValue: buildTimeData(schedule.firstMilePickupTime) || {},
                    cutoffValue: buildTimeData(schedule.firstMileCutoff) || {},
                    frequency: buildScheduleData(schedule.firstMilePickupDays)
                },
                lastMile: {
                    pickupTimeValue: buildTimeData(schedule.lastMilePickupTime) || {},
                    cutoffValue: buildTimeData(schedule.lastMileCutoff) || {},
                    frequency: buildScheduleData(schedule.lastMilePickupDays)
                }
            });
        }

        function buildScheduleData(frequency) {
            return angular.getObjVal(frequency, 'frequencyValues');
        }

        function getDaysData(day) {
            if (!day) { return; }
            return vm.days.find(d => d.value === day);
        }

        function buildTimeData(timeString) {
            if (!timeString) { return; }
            const timeFragment = timeString.split(':');
            return {
                hour: timeFragment[0],
                min: timeFragment[1],
            }
        }

        function searchOffices(select) {
            if (!select.open) {
                return false;
            }
            vm.dropdownFetching = true;
            vm.offices = [];
            ClientService.Location.getAll(data => {
                vm.offices = data.content;
                vm.dropdownFetching = false;
            }, error => {
                toastr.error('Unable to fetch service profiles', error.message);
                vm.dropdownFetching = false;
            }, {
                size: 50,
                name: select.search
            });
        }

        function searchServiceProfile(select, carrierProfile) {
            if (!select.open) {
                return false;
            }
            vm.dropdownFetching = true;
            vm.serviceProfiles = [];
            Carrier.getServiceProfiles(data => {
                vm.serviceProfiles = data.content;
                vm.dropdownFetching = false;
            }, error => {
                toastr.error('Unable to fetch service profiles', error.message);
                vm.dropdownFetching = false;
            }, {
                size: 10,
                name: select.search,
                carrierProfile: carrierProfile ? carrierProfile.id : undefined
            });
        }

        function onSelectCarrierProfile() {
            vm.schedule.serviceProfile = {};
            vm.isBreakBulk = vm.schedule.carrierProfile.carrier.id === 'break-bulk';
        }

        // todo: add filter here
        function searchCarrierProfiles(select) {
            if (!select.open) {
                return false;
            }
            vm.dropdownFetching = true;
            vm.carrierProfiles = [];
            Carrier.getExternalCarrierProfiles(data => {
                vm.carrierProfiles = data.content;
                vm.dropdownFetching = false;
            }, error => {
                toastr.error('Unable to fetch carrier profiles', error.message);
                vm.dropdownFetching = false;
            }, { size: 10, name: select.search });
        }

        function save(form) {
            form.$setSubmitted();
            if (form.$invalid) return false;
            const payload = ClientService.Client.payloadMapper(vm.schedule, vm.isBreakBulk);
            
            vm.saving = true;
            if (vm.schedule.id) {
                updateSchedule(payload);
                return false;
            }
            
            createSchedule(payload);
        }

        function updateSchedule(payload) {
            ClientService.Location.updatePickupSchedules(vm.schedule.id, data => {
                toastr.success('Scheduled pickup updated', 'Success!');
                $uibModalInstance.close();
            }, err => {
                toastr.error('Unable to update scheduled pickup', err.message);
                $uibModalInstance.close();
            }, payload);
        }

        function createSchedule(payload) {
            ClientService.Location.createPickupSchedules(data => {
                $uibModalInstance.close();
                toastr.success('Scheduled pickup created', 'Success!');
            }, err => {
                toastr.error('Unable to create scheduled pickup', err.message);
                $uibModalInstance.close();
            }, payload);
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/client/OfficeLocation/ScheduledPickupModalController.js